import { getEnv } from "@ace/env";

export type ModalSeenStatus = {
  showModal: boolean;
  shownOn: string;
};

/**
 * Returns the backend status of a modal that needs to be show (or not) to a user and when it was last registered to have been shown.
 *
 * @param token
 * @param modalName
 * @returns ModalStatus
 */
const getRegistrationStatusOfModalForUser = async (
  token: string,
  modalName: string,
): Promise<ModalSeenStatus> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const response = await fetch(
    `${getEnv("VITE_ACE_WEB_AUTH_SERVER")}/modal-shown?modal=${modalName}`,
    {
      method: "GET",
      headers,
    },
  );
  const json = await response.json();

  if (json.status === "ERROR") {
    throw new Error(json.error[0].msg);
  }

  const data = json.data as ModalSeenStatus;

  return data;
};

export { getRegistrationStatusOfModalForUser };
